/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-boolean-value */
import React, {
  useEffect, useState, Suspense, lazy,
} from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import {
  Col, Empty, Row, message,
} from 'antd';
import ListCardGlobal from 'modules/Common/Components/ListCardGlobal';
import SecondaryHeading from 'modules/Common/Components/SecondaryHeading';
import styled from 'styled-components';
import ViewSwitcherComponent from 'modules/Common/Components/ViewSwitcherComponent';
import InfiniteScroll from 'react-infinite-scroll-component';
import classNames from 'classnames';
import { maxTablet, maxWidth, retina } from 'constants/utilsStyles';
import ListCardSkeleton from 'modules/Common/Skeleton/ListCardSkeleton';
import SkeletonCustom from 'modules/Common/Skeleton/SkeletonCustom';
// import ConfirmDialogWithModal from 'modules/Common/Components/ConfirmDialogWithModal';
import AudienceDeletePopup from 'modules/Common/Components/AudienceDeletePopup';
import { addGillRoyIconWhenAudienceSelected, removeGillRoyIconWhenAudienceSelected } from 'utils';
// import ConfirmDialog from 'modules/Common/Components/ConfirmDialog';

// import ListItemCustomLoader from 'modules/Common/ListItemCustomLoader';
// import AssetsCardPlaceHolder from 'modules/Campaigns/AssetsWithOutCampaigns/Components/AssetsCardPlaceHolder';
import ConfirmDialogWithModal from 'modules/Common/Components/ConfirmDialogWithModal';
import {
  getAudienceListsAction,
  getAudienceSearchedListsAction,
  deleteAudienceListAction,
  resetAudienceSearchedList,
  audienceListSelectionSetAction,
  audienceListSelectionResetAction,
  resetAudienceList,
  listAttachedWithWorkflowAction,
} from '../Actions/listsActions';

const ContactsFooterWrapper = lazy(() => import('modules/Audience/Components/Footer/ContactsFooter'));

type Props = {
  page: string | undefined; // will fix after component building
  listView: boolean;
  isDashboard?: boolean;
};

const Wrapper = styled.div`
  margin-top: 15px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    margin-top: 10px;
  }
  .heading-div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-right: 10px;
    margin-bottom: 0px;
    .view-switch-cmp {
      margin-right: 15px;
      @media all and (max-width: ${maxTablet}) {
        margin-right: 6px;
      }
    }
  }
  .aud-Infinite-scroll {
    .audience-module-row {
      &.emptyRowList {
        height: calc(100% - 30px);
        .no-data-found {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
    }
  }
  .list-card-global {
    margin-bottom: 10px;
    height: 97%;
    &.tileView {
      margin-bottom: 0px;
      .aud-Infinite-scroll {
        .audience-module-row {
          @media all and ((min-width: ${maxTablet}) and (max-width: ${maxWidth})), ${retina} {
            margin-left: 0px !important;
          }
        }
      }
    }
  }
`;

const AudienceLists = (props: Props) => {
  const { page: pageName, listView, isDashboard } = props;

  const [isSearched, setIsSearched] = useState(false);
  const [showFooter, setShowFooter] = useState<boolean>(false);
  const [selectedListIds, setSelectedListsIds] = useState<number[]>([]);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [showWorkflowPopup, setShowWorkflowPopup] = useState<boolean>(false);
  const [workflowAttachCount, setWorkflowAttachCount] = useState<number>(0);

  const {
    page, lists, loading, searchedLoading, totalLists, totalSearchedLists, searchTerm, searchedLists, searchedPage, deleteList,
  } = useSelector(
    (state: RootState) => state.audienceListsReducerV2,
  );
  const { listId: listDetailListId } = useSelector((state: RootState) => state.audienceListDetailsReducerV2);
  const isGlobalContactsSelected = useSelector((state: RootState) => state.globalContacts.isGlobalContactsSelected);

  const getParams = (listsLength: number, pageNumber: number) => {
    const limit = 20;
    const offset = pageNumber > 0 ? listsLength : 0;
    const searchByListName = searchTerm;

    return {
      limit,
      offset,
      search_by_list_name: searchByListName,
    };
  };

  const loadMore = () => {
    if (isSearched) {
      if (!searchedLoading) {
        // Disabling estlint for next line as promises are not required
        // eslint-disable-next-line
        getAudienceSearchedListsAction(getParams(searchedLists.length, searchedPage));
      }
    } else if (!loading) {
      getAudienceListsAction(getParams(lists.length, page));
    }
  };

  const handleIsSearchMode = () => {
    if (searchTerm !== '') {
      setIsSearched(true);
    } else {
      setIsSearched(false);
    }
  };

  const handleSelectLists = (listId: number) => {
    if (selectedListIds.includes(listId)) {
      const listIds = [...selectedListIds].filter((item) => item !== listId).map((item) => item);
      if (listIds.length > 0) {
        setShowFooter(true);
      } else {
        setShowFooter(false);
      }
      setSelectedListsIds(listIds);
    } else {
      setSelectedListsIds([listId, ...selectedListIds]);
      if (!showFooter) {
        setShowFooter(true);
      }
    }
  };

  const clearSelection = () => {
    setSelectedListsIds([]);
    setShowFooter(false);
  };

  const handleCloseConfirmationDialog = () => {
    setShowConfirmation(false);
  };

  const handleCloseWorkflowDeleteDialog = () => {
    setShowWorkflowPopup(false);
  };

  const getConfirmationString = () => {
    if (selectedListIds.length > 1) {
      return 'Selected List(s) are being used in the following component(s)';
    }
    return 'Selected List is being used in the following component(s)';
  };

  const getDeleteConfirmationString = () => {
    if (selectedListIds.length > 1) {
      return 'Are you sure you want to delete these lists?';
    }
    return 'Are you sure you want to delete this list?';
  };

  const handleConfirmDeleteList = () => {
    if (selectedListIds.length > 0) {
      setShowConfirmation(false);
      if (showWorkflowPopup) setShowWorkflowPopup(false);
      clearSelection();
      deleteAudienceListAction(selectedListIds, isSearched)
        .then(() => {
          // Success Taoster
          // eslint-disable-next-line
          message.success({
            content: 'List has been deleted successfully.',
          });
        })
        .catch((err) => {
          // Error Taoster
          // eslint-disable-next-line
          message.error({
            content: 'Unable to delete list. Please try again later or contact support at support@xiqinc.com.',
          });
          console.log(err);
        });
    }
  };

  const checkListAttachedBeforeDelete = (listId = 0) => {
    const id = listId.toString() === 'DELETE_CONTACT' ? 0 : listId;
    const listIds = id ? [id] : selectedListIds;
    if (listIds.length > 0) {
      listAttachedWithWorkflowAction(listIds, setShowWorkflowPopup, setWorkflowAttachCount, setShowConfirmation);
    }
  };

  const handleShowConfirmationDialog = (listId: number) => {
    setSelectedListsIds([listId]);
    checkListAttachedBeforeDelete(listId);
  };

  useEffect(() => {
    if (lists.length === 0 || page === 0) {
      if (page === 0) {
        resetAudienceList();
        resetAudienceSearchedList();
      }
      getAudienceListsAction(getParams(lists.length, page));
    }

    if (pageName === undefined) {
      resetAudienceSearchedList();
    }
  }, []);

  useEffect(() => {
    handleIsSearchMode();
  }, [loading, searchTerm]);

  useEffect(() => {
    if (selectedListIds.length === 0) {
      audienceListSelectionResetAction();
      addGillRoyIconWhenAudienceSelected();
    } else {
      audienceListSelectionSetAction();
      removeGillRoyIconWhenAudienceSelected();
    }
  }, [selectedListIds]);

  const firstLoading = isSearched ? searchedLoading && searchedLists.length === 0 : loading && lists.length === 0;

  const loadingLists = deleteList.loading || (isSearched ? searchedLoading : loading);

  return (
    <>
      <Wrapper className={classNames('sub-container', { mainContainer: !isDashboard, listViewSHow: listView, blockViewShow: !listView })}>
        {showWorkflowPopup && (
          <AudienceDeletePopup
            cancel="Cancel"
            confirm="Delete"
            onConfirm={handleConfirmDeleteList}
            onCancel={handleCloseWorkflowDeleteDialog}
            title={getConfirmationString()}
            list="Workflow Automation"
            count={workflowAttachCount}
            titleQuestion={null}
          />
        )}
        {showConfirmation && (
          <ConfirmDialogWithModal
            cancel="Cancel"
            confirm="Delete"
            onConfirm={handleConfirmDeleteList}
            onCancel={handleCloseConfirmationDialog}
            title={getDeleteConfirmationString()}
            titleQuestion={null}
          />
        )}
        {firstLoading ? (
          <div className="heading-div">
            {[1, 2].map((item) => (
              <SkeletonCustom key={`list-skeleton-filter-${item}`} height="30px" width="120px" diameter="8px" margin="0 0 0 10px" />
            ))}
          </div>
        ) : (
          <div className="heading-div">
            <SecondaryHeading title={`Lists (${isSearched ? totalSearchedLists : totalLists})`} />
            <ViewSwitcherComponent goBackLink="/audiences/" viewSwitch={pageName === 'lists'} redirectLink="/audiences/lists" />
          </div>
        )}
        <InfiniteScroll
          dataLength={isSearched ? searchedLists?.length : lists.length}
          next={loadMore}
          hasMore={isSearched ? searchedLists.length < totalSearchedLists : lists.length < totalLists}
          loader={false}
          height="auto"
          className={classNames('aud-Infinite-scroll', {
            gridViewInfiniteDiv: !listView,
            tileViewInfiniteDiv: listView,
            limitedStats: isSearched ? searchedLists.length < 4 : lists.length < 4,
          })}
        >
          <Row
            gutter={[24, listView ? 8 : 8]}
            className={classNames('audience-module-row mt-c-10 mb-c-10', {
              emptyRowList: [...(isSearched ? searchedLists : lists)].length === 0 && !loading, // here
            })}
          >
            {!deleteList.loading
              && [...(isSearched ? searchedLists : lists)].map((list) => (
                <Col
                  span={listView ? 24 : 6}
                  className={classNames('audience-module-col audience-card', {
                    gridCol: !listView,
                    tileViewCol: listView,
                  })}
                >
                  <ListCardGlobal
                    listView={listView}
                    list={list}
                    handleSelection={handleSelectLists}
                    selectedCount={selectedListIds.length}
                    actionHandler={handleShowConfirmationDialog}
                    disableSelect={isGlobalContactsSelected}
                    isSearched={isSearched}
                    listDetailListId={listDetailListId}
                    isSelected={selectedListIds.includes(list.listId)}
                  />
                </Col>
              ))}
            {loadingLists
              && [1, 2, 3].map((item) => (
                <Col
                  span={listView ? 24 : 6}
                  className={classNames('audience-module-col', {
                    gridCol: !listView,
                    tileViewCol: listView,
                  })}
                >
                  <ListCardSkeleton key={`col-list-loader-st${item}`} listView={listView} />
                </Col>
              ))}
            {[...(isSearched ? searchedLists : lists)].length === 0 && !loading && !searchedLoading ? (
              <div className="no-data-found" style={{ width: '100%' }}>
                <Empty
                  description={`${isSearched
                    ? 'No list(s) found against your search'
                    : 'Your list(s) will show up here once you will import a list or create a new list.'
                    }`}
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              </div>
            ) : null}
          </Row>
        </InfiniteScroll>
      </Wrapper>
      <Suspense fallback={<></>}>
        <ContactsFooterWrapper
          toggle={showFooter}
          list={true}
          showAddToList={false}
          count={selectedListIds.length}
          clearSelection={clearSelection}
          handleConfirmation={checkListAttachedBeforeDelete}
        />
      </Suspense>
    </>
  );
};

AudienceLists.defaultProps = {
  isDashboard: false,
};

export default AudienceLists;
